(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitReopenFranchiserController', UnitReopenFranchiserController)

    /** @ngInject */
    function UnitReopenFranchiserController($q, $state, HelperService, UnitService, NotifyService, sweetAlert) {
        const vm = this;
        let allUnits;

        vm.prepareReopenUnit = () => {
            HelperService.startLoading('.loading-holder');

            $q.all([getUnits(), getTypes()])
                .then(() => {
                    vm.step = 2;
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.getUnits = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = allUnits.filter(unit => filterUnit(unit, search))
        }

        vm.reopenUnit = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você está prestes a criar uma nova loja utilizando o identificador único da loja selecionada, essas lojas estarão associadas no histórico. Essa ação é irreversível!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    if (!vm.selectedType) {
                        HelperService.setErrorMessageForm('.type');
                        return;
                    }

                    if (!vm.selectedUnitToReopen.Phone) {
                        HelperService.setErrorMessageForm('.phone');
                        return;
                    }

                    HelperService.startLoading('.page-content');

                    let unitReopenData = {
                        Id: vm.selectedUnitToReopen.Id,
                        UnitTypeId: vm.selectedType.Id,
                        Unit_Phone: [{
                            PhoneTypeId: 1,
                            Phone: {
                                Code: vm.selectedUnitToReopen.Phone.substring(0, 2),
                                Number: vm.selectedUnitToReopen.Phone.substring(2, 10)
                            }
                        }]
                    }

                    UnitService
                        .reopenUnit(unitReopenData)
                        .then(success => {
                            $state.go('app.franchiser-units-edit', {
                                unitId: success.Id
                            });

                            NotifyService.success('Loja reaberta com sucesso');
                            HelperService.stopLoading('.page-content');
                        }, error => {
                            HelperService.stopLoading('.page-content');
                            HelperService.errorCallback(error);
                        })
                }
            })
        }

        init();

        function getTypes() {
            return UnitService
                .getTypes()
                .then(success => {
                    vm.types = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getUnits() {
            return UnitService
                .getAllClosedResumed()
                .then(success => {
                    allUnits = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function filterUnit(unit, search) {
            if (unit.CorporateName == null)
                unit.CorporateName = '';

            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()) || unit.CorporateName.toLowerCase().includes(search.toLowerCase()) || unit.UniqueCode.toString().includes(search) || unit.ExternalCode.toString().includes(search))
                return unit;
        }

        function init() {
            vm.step = 1;
            vm.selectedType;
        }
    }
}());